import { render, staticRenderFns } from "./createSonTask.vue?vue&type=template&id=02a9e49f&scoped=true&"
import script from "./createSonTask.vue?vue&type=script&lang=js&"
export * from "./createSonTask.vue?vue&type=script&lang=js&"
import style0 from "./createSonTask.vue?vue&type=style&index=0&id=02a9e49f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a9e49f",
  null
  
)

export default component.exports